// src/pages/RefundForm.js
import Select from "react-select";
import { getRefundBoothList } from "../../services/Booths";
import { useEffect, useRef, useState } from "react";
import { createRefunds, uploadEvidence, getRefundNoteOptions } from "../../services/Refunds";
import { useNavigate } from "react-router-dom";
import ls from "local-storage";
import imageCompression from "browser-image-compression";
import Moment from "moment";

const RefundForm = () => {
  const [formData, setFormData] = useState({
    nama: "",
    id_refund_notes: "",
    kendala: "",
    noHp: "",
    email: "",
    instagram: "",
    norek: "",
    bank: "",
    penerima: "",
    jumlah: "",
    booth: null, // NEW
    tanggal: new Date().toISOString().split("T")[0], // e.g. '2025-04-07'
    agreement: false,
    buktiPembayaran: null,
    buktiKendala: null,
  });
  const navigate = useNavigate();
  const [boothOptions, setBoothOptions] = useState([]);
  const [problemOptions, setProblemOptions] = useState([]);

  function fetchBooths() {
    getRefundBoothList().then((response) => {
      setBoothOptions([
        ...response.data.map((item) => {
          return {
            ...item,
            label: `${item.display_name} - ${item.cityName}`,
            value: item.id,
          };
        }),
      ]);
    });
  }

  function fetchRefundOptions() {
    getRefundNoteOptions().then((response) => {
      const groupedOptions = [...response.data];
      setProblemOptions(groupedOptions);
    });
  }

  useEffect(() => {
    fetchBooths();
    fetchRefundOptions();
    fetchLS();
  }, []);
  function fetchLS() {
    if (ls.get("userDetail")) {
      const userDetail = ls.get("userDetail");
      setFormData({
        ...formData,
        nama: userDetail.nama,
        noHp: userDetail.noHp,
        email: userDetail.email,
        instagram: userDetail.instagram,
      });
    }
  }
  const [files, setFiles] = useState([]);
  const [fileProblems, setFileProblems] = useState([]);
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e) => {
    const tmpfiles = Array.from(e.target.files);

    if (tmpfiles.length > 3) {
      alert("Kamu cuma bisa upload maksimal 3 file ya.");
      e.target.value = "";
      return;
    }

    setFiles(tmpfiles);
  };
  
  const handleFileProblemChange = (e) => {
    const tmpfiles = Array.from(e.target.files);

    if (tmpfiles.length > 3) {
      alert("Kamu cuma bisa upload maksimal 3 file ya.");
      e.target.value = "";
      return;
    }

    setFileProblems(tmpfiles);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);

    //validate images
    const imagesValid = files.every((file) => file.type.startsWith("image/"));
    if (!imagesValid) {
      alert("Harap pilih file berupa gambar");
      setLoading(false);
      return;
    }

    //upload evidence
    const uploadEvidence = await uploadFileEvidence();
    const uploadProblemEvidence = await uploadFileProblemEvidence();

    if (uploadEvidence.uploadSuccess === false) {
      alert("Gagal mengupload bukti pembayaran. Harap ulangi beberapa saat lagi.");
      setLoading(false);
      return;
    }
    
    if (uploadProblemEvidence.uploadSuccess === false) {
      alert("Gagal mengupload bukti kendala. Harap ulangi beberapa saat lagi.");
      setLoading(false);
      return;
    }

    const payload = {
      ...formData,
      jumlah          : formData.jumlah.replace(/[^0-9]/g, ""),
      buktiPembayaran : JSON.stringify(uploadEvidence.uploadedFiles),
      buktiKendala    : JSON.stringify(uploadProblemEvidence.uploadedFiles),
    };

    setSubmitted(false);

    try {
      const response = await createRefunds(payload); // Your API should accept JSON
      if (response.success === 1) {
        navigate("/refund/success", { state: payload }); // 🚀 redirect with form data
        ls.set("userDetail", {
          nama: formData.nama,
          noHp: formData.noHp,
          email: formData.email,
          instagram: formData.instagram,
        });

        setSubmitted(true);
        setFormData({
          nama: "",
          id_refund_notes: "",
          kendala: "",
          noHp: "",
          email: "",
          instagram: "",
          norek: "",
          bank: "",
          penerima: "",
          jumlah: "",
          tanggal: new Date().toISOString().split("T")[0],
          cabang: null,
          agreement: false,
          buktiPembayaran: null,
          buktiKendala: null,
        });
        setFiles([]);
      } else {
        alert("Gagal mengirim permintaan refund. Silakan coba lagi.");
      }
    } catch (err) {
      console.error("Error during refund submission:", err);
      alert("Terjadi kesalahan. Silakan coba lagi.");
    } finally {
      setLoading(false);
    }
  };

  async function uploadFileEvidence() {
    let uploadSuccess = true;
    let uploadedFiles = [];
    for (const file of files) {
      const options = {
        maxSizeMB: 2,
        maxWidthOrHeight: 3000,
      };

      const compressedFile = await imageCompression(file, options);
      let momentDate = Moment(new Date()).format("YYYYMMDD-HHmmss");

      const response = await uploadEvidence(compressedFile, formData.booth.id, momentDate);
      if (response.data.success === 1) {
        uploadedFiles.push(response?.data.resUrl);
      } else {
        uploadSuccess = false;
        break;
      }
    }

    return { uploadSuccess, uploadedFiles };
  }

  async function uploadFileProblemEvidence() {
    let uploadSuccess = true;
    let uploadedFiles = [];
    for (const file of fileProblems) {
      const options = {
        maxSizeMB: 2,
        maxWidthOrHeight: 3000,
      };

      const compressedFile = await imageCompression(file, options);
      let momentDate = Moment(new Date()).format("YYYYMMDD-HHmmss");

      const response = await uploadEvidence(compressedFile, formData.booth.id, momentDate);
      if (response.data.success === 1) {
        uploadedFiles.push(response?.data.resUrl);
      } else {
        uploadSuccess = false;
        break;
      }
    }

    return { uploadSuccess, uploadedFiles };
  }

  return (
    <div className="min-h-screen bg-[#2b478e] px-4 py-8 flex justify-center">
      <div className="w-full max-w-2xl bg-white rounded-md shadow-md p-6">
        <center>
          {" "}
          <h1 className="text-2xl font-semibold mb-1">Form Refund Sukhakala</h1>
        </center>

        <ul className="list-unstyled text-sm text-gray-600 mb-6 mt-6 lh-lg">
          <li className="mb-3 md:mb-1">🗓️ Pengajuan refund dapat dilakukan maksimal H+7 dari tanggal transaksi.</li>
          <li className="mb-3 md:mb-1">
            ⏱️ Refund akan diproses dalam waktu maksimal 2x24 jam Hari Kerja setelah pengajuan diterima.
          </li>
          <li className="mb-3 md:mb-1">✍️ Pastikan data yang kamu isi akurat untuk mempercepat proses refund.</li>
          <li className="mb-3 md:mb-1">📩 Kamu akan dikabari melalui WhatsApp atau email yang terdaftar.</li>
        </ul>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="block mb-1 font-medium text-gray-800">
              Booth yang dikunjungi <span className="text-red-500">*</span>
            </label>
            <Select
              options={boothOptions}
              value={formData.booth}
              onChange={(selected) => setFormData({ ...formData, booth: selected })}
              placeholder="Pilih booth"
              isSearchable
              required
            />
          </div>
          <div>
            <label className="block mb-1 font-medium text-gray-800">
              Tanggal Transaksi <span className="text-red-500">*</span>
            </label>
            <input
              type="date"
              name="tanggal"
              value={formData.tanggal}
              onChange={handleChange}
              min={new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString().split("T")[0]}
              max={new Date().toISOString().split("T")[0]}
              required
              className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-purple-500"
            />
          </div>
          {[
            { name: "nama", label: "Nama" },
            { name: "id_refund_notes", label: "Jenis Kendala" },
            { name: "kendala", label: "Penjelasan Kendala" },
            { name: "noHp", label: "No HP (Pastikan aktif dan terhubung dengan WhatsApp)" },
            { name: "email", label: "Email" },
            { name: "instagram", label: "Username Instagram" },
            { name: "norek", label: "Nomor Rekening" },
            { name: "bank", label: "Nama Bank" },
            { name: "penerima", label: "Nama Penerima" },
            { name: "jumlah", label: "Jumlah Refund" },
          ].map((field) =>
            field.name === "id_refund_notes" ? (
              <div key={field.name}>
                <label className="block mb-1 font-medium text-gray-800">
                  {field.label} <span className="text-red-500">*</span>
                </label>
                <Select
                  options={problemOptions}
                  value={problemOptions.find(option => option.value === formData[field.name])}
                  getOptionLabel={(option) => option.label}
                  getOptionValue={(option) => option.value}
                  onChange={(selectedOption) => {
                    setFormData({ 
                      ...formData, 
                      id_refund_notes: selectedOption.value 
                    });
                  }}
                  placeholder="Pilih kendala"
                  isSearchable
                  required
                />
              </div>
            ) : (
              <div key={field.name}>
                <label className="block mb-1 font-medium text-gray-800">
                  {field.label} <span className="text-red-500">*</span>
                </label>
                <input
                  type={field.name === "email" ? "email" : field.name === "jumlah" ? "number" : "text"}
                  name={field.name}
                  onWheel={(e) => e.target.blur()}
                  placeholder={field.name === "kendala" ? "Mohon berikan penjelasan yang jelas dan lengkap" : `Masukkan ${field.label}`}
                  value={formData[field.name]}
                  onChange={handleChange}
                  required
                  className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-purple-500"
                />
              </div>
            )
          )}

          <div>
            <label className="block mb-1 font-medium text-gray-800">
              Bukti Pembayaran <span className="text-red-500">*</span>
            </label>
            <input
              type="file"
              onChange={handleFileChange}
              multiple
              required
              className="w-full text-sm"
              accept=".jpg,.jpeg,.png"
            />
            <p className="text-sm text-gray-500 mt-1">Kamu bisa upload lebih dari 1 file</p>
          </div>

          <div>
            <label className="block mb-1 font-medium text-gray-800">
              Bukti Kendala <span className="text-red-500">*</span>
            </label>
            <input
              type="file"
              onChange={handleFileProblemChange}
              multiple
              required
              className="w-full text-sm"
              accept=".jpg,.jpeg,.png"
            />
            <p className="text-sm text-gray-500 mt-1">Kamu bisa upload lebih dari 1 file</p>
          </div>

          <div className="mb-4">
            <label className="flex items-start gap-2 text-sm sm:text-base">
              <input
                type="checkbox"
                checked={formData.agreement}
                onChange={(e) => setFormData({ ...formData, agreement: e.target.checked })}
                className="mt-1"
              />
              <span>
                Saya mengerti bahwa proses refund memerlukan waktu <strong>2x24 jam hari kerja</strong>
              </span>
            </label>
            {!formData.agreement && submitted && (
              <p className="text-red-500 text-sm mt-1">Checklist ini wajib dicentang.</p>
            )}
          </div>
          <button
            type="submit"
            disabled={!formData.agreement || loading}
            className={`w-full py-2 text-white font-semibold rounded ${
              !formData.agreement || loading ? "bg-gray-400" : "bg-blue-500 hover:bg-blue-600"
            }`}
          >
            {loading ? "Mengirim..." : "Kirim"}
          </button>

          {submitted && <p className="text-green-600 font-medium mt-2">Permintaan refund berhasil dikirim!</p>}
        </form>
      </div>
    </div>
  );
};

export default RefundForm;
